import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import HaggleInvitesTable from '@/components/table/haggle-invites/HaggleInvitesTable';
import {
	DEFAULT_PAGE_SIZE,
	PAGE_SIZE_OPTIONS,
} from '@/components/utils/constants';
import { useUser } from '@/hooks/useUser';
import { ApiQueryKeys } from '@/interfaces/api/ApiQueryKeys';
import { ICollectionHaggleInvite } from '@/interfaces/api/invite/IInvite';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

const HaggleInvitedUsers = () => {
	const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
	const [pageNumber, setPageNumber] = useState(1);
	const { user } = useUser();

	const {
		data: invites,
		isLoading,
		isError,
		error,
		refetch,
	} = useQuery<ICollectionHaggleInvite>({
		queryKey: [ApiQueryKeys.getHaggleAllInvites, pageSize, pageNumber],
		queryFn: () =>
			haggleApiService.getHaggleAllInvites({
				params: {
					page: pageNumber,
					limit: pageSize,
					merchantId: user?.id,
				},
			}),
		refetchOnWindowFocus: false,
	});

	if (isError && error instanceof Error) {
		notificationService.error(error.message);
	}

	const pagination = {
		pageSize,
		pageNumber,
		pageCount: invites?.pageCount ?? 0,
		itemCount: invites?.itemCount ?? 0,
		pageSizeOptions: PAGE_SIZE_OPTIONS,
		setPageSize,
		setPageNumber,
	};

	return (
		<div
			className="flex flex-col justify-center items-center w-full"
			data-test="invited-users"
		>
			{isLoading && <div>Loading...</div>}

			{invites && !isLoading && (
				<HaggleInvitesTable
					invites={invites.data}
					pagination={pagination}
					refetch={refetch}
				/>
			)}
		</div>
	);
};

export default HaggleInvitedUsers;
